import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-8edd2bda"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "page-qrcode" }
const _hoisted_3 = { class: "title" }
const _hoisted_4 = ["src"]

import { authStore } from '@/stores';
  import download from 'downloadjs';
  import { ColorVariants } from '@/constants';
  import { useI18n } from 'vue-i18n';

  
export default /*#__PURE__*/_defineComponent({
  setup(__props) {

  const { t } = useI18n();
  authStore.tryFetchData();

return (_ctx: any,_cache: any) => {
  const _component_b_button = _resolveComponent("b-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h2", _hoisted_3, _toDisplayString(_unref(t)('My QR code')), 1),
      _createElementVNode("img", {
        src: _unref(authStore).user.qrcode?.url,
        crossorigin: "anonymous"
      }, null, 8, _hoisted_4),
      (_unref(authStore).user.qrcode?.url)
        ? (_openBlock(), _createBlock(_component_b_button, {
            key: 0,
            class: "btn-download",
            pill: "",
            variant: _unref(ColorVariants).primary,
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(download)(_unref(authStore).user.qrcode?.url || '')))
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(t)('download')), 1)
            ]),
            _: 1
          }, 8, ["variant"]))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})